import { arrayOf, bool, func, number } from 'prop-types';
import React from 'react';

import { detailedInvoiceShape, productShape } from '../../../prop-types';
import InvoiceLine from './InvoiceLine';

function ListInvoices({
  invoices,
  readOnly,
  products,
  onDelete,
  onUpdateStatus,
  loading,
  LineComponent,
  openInvoiceId,
  isEditing,
}) {
  return invoices.map(invoice => (
    <LineComponent
      invoice={invoice}
      products={products}
      key={invoice.id}
      onDelete={onDelete}
      onUpdateStatus={onUpdateStatus}
      loading={loading}
      readOnly={readOnly}
      isOpenByDefault={openInvoiceId === invoice.id}
      isEditing={isEditing}
    />
  ));
}

ListInvoices.propTypes = {
  invoices: arrayOf(detailedInvoiceShape.isRequired).isRequired,
  products: arrayOf(productShape.isRequired).isRequired,
  onDelete: func,
  onUpdateStatus: func,
  loading: bool,
  openInvoiceId: number,
  isEditing: bool,
};

ListInvoices.defaultProps = {
  LineComponent: InvoiceLine,
  openInvoiceId: undefined,
  isEditing: true,
};

export default ListInvoices;
